import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  List as MuiList,
  ListItem as MuiListItem,
  ListItemText as MuiListItemText,
  ListItemAvatar as MuiListItemAvatar,
  ListItemIcon as MuiListItemIcon,
  CircularProgress as MuiCircularProgress,
} from "@mui/material";

export const List = styled(MuiList)(({ theme }) => ({
  position: "relative",
  padding:0,
  textAlign: "center",
  backgroundColor: theme.palette.background.paper,
  overflow: "auto",
  borderRadius: "5px",
  height:"100%",
  "&.set-height":{
    height:"calc(100% - 60px)"
  },
  "& .data":{
    backgroundColor: "#fff",
    justifyContent:"center",
  },
  "&>:nth-of-type(odd)": {
    backgroundColor: "#fff",
    "&.data":{
      backgroundColor: "#fff",
    }
  },
  "&>:nth-of-type(even)": {
    backgroundColor: theme.palette.grey[600],
    "&.data":{
      backgroundColor: "#fff",
    }
  },
  "& .MuiListItem-container": {
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& *": {
        color: "#fff",
      },
    },
    "& .Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemText-root .MuiTypography-root": {
        color: "#fff",
      },
      "& + .MuiListItemSecondaryAction-root .MuiIconButton-root": {
        color: "#fff",
      },
    },
  },
}));
export const ListItem = styled(MuiListItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&.listWithoutAvatar":{
    "&:hover": {
      "& .MuiListItemIcon-root": {
        display:  "block",
        left:  "0px",
      },
  },
  },
  "&.hightLightItemOrange":{
    backgroundColor:"#F8D89E",
    borderBottom:"1px solid #f1c77b",
    "& .MuiListItemText-root .MuiTypography-root": {
      color: "#d88c02",
    },
    "&:hover": {
      backgroundColor:"#f8c871",
      "& .MuiListItemText-root .MuiTypography-root": {
        color: "#d88c02",
      },
    }
  },  
  "&.hightLightItemRed":{
    backgroundColor:"#F6E8E6",
    borderBottom:"1px solid #f7d7d2",
    "& .MuiListItemText-root .MuiTypography-root": {
      color: "#f36d5a",
    },
    "&:hover": {
      backgroundColor:"#f6d0ca",
      "& .MuiListItemText-root .MuiTypography-root": {
        color: "#f36d5a",
      },
    }
  },
  "&:hover": {
    "& .MuiListItemIcon-root": {
      display: "block",
      left: "13px",
    },
    "& .MuiListItemAvatar-root": {
      display: "none",
    },
  },
}));
export const ListItemText = styled(MuiListItemText)({
  "& .MuiListItemText-primary": {
    fontWeight: "bold",
    fontSize: "16px",
    display:"inline",
  },
  "& .MuiListItemText-secondary": {
    marginLeft: "5px",
    fontSize: "14px",
    display:"inline",
  },
});
export const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: "initial",
  mr: "14px",
  color: "#fff",
  "&.abc": {
    display: "none",
  },
  // "&.selectedStyle":{
  //   "& .MuiAvatar-root": {
  //     backgroundColor: #fff",
  //     color: (theme) => theme.palette.primary.main,
  //   },
  // }
});
export const ListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  position: "relative",
  display: "none",
  "&.iconWithoutAvatar":{
    display: "block",
    minWidth:"40px",
  },
  "& .MuiCheckbox-root":{
    color: theme.palette.grey[800],
  },
}));
export const BulkActionBtn = styled(Button)(({ theme }) => ({
  borderRadius: "12px",
  height: "25px",
  whiteSpace: "nowrap",
  fontWeight: "bold",
  marginRight: "20px",
  "&:hover": {},
  "&.right":{
    marginLeft: "20px",
    marginRight: "0px",
  }
}));
export const BulkDiv = styled(Box)(({ theme }) => ({
  height: "60px",
  backgroundColor: theme.palette.grey[500],
  color: "#fff",
  fontSize: "18px",
  padding: "0 16px",
  display: "flex",
  alignItems: "center",
  borderTopLeftRadius: "5px",
  borderTopRightRadius: "5px",
}));
export const CircularProgress = styled(MuiCircularProgress)({
  marginTop: "20px", marginBottom: "20px",
});
